export default __webpack_public_path__ + "static/media/icons8-opera-mini.67f9816a.svg";